/**
 * Created by fers on 05.02.16.
 */
import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import types from '../../common/model-api/types';
import Relay from 'react-relay';
import GridList, {processPagingParams} from '../fw/GridList.react';
import {defaultPageSize} from '../fw/PagingGrid.react';
import {FormattedMessage, injectIntl, defineMessages, IntlShape} from 'react-intl';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';

import urlMapping from '../app/URLMapping';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'channelAdd.title', 'defaultMessage': 'Adding App'},
    search: {id: 'channelAdd.search', 'defaultMessage': 'Search'}
});

interface ChannelAddProps {
    intl: IntlShape;
    relay: object;
    user: User;
}

class ChannelAdd extends React.Component<ChannelAddProps> {

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
    };
    typeName = 'channels';

    constructor() {
        super();
    }

    onChange = (event) => {
        let lastValue = event.target.value;

        /* wait 250 ms after last change */
        if (this.delayTimeout) {
            clearTimeout(this.delayTimeout);
        }

        this.delayTimeout = setTimeout(() => {
            this.props.relay.setVariables({
                searchName: lastValue
            });
        }, 250);
    };

    getUrl = (item) => {
        return urlMapping.getUrl(types[this.typeName], 'create-step-1', {
            organisation_id: this.props.user.organisation.realId,
            id: item['id']
        });
    };

    render() {
        const {channelDefsToAdd} = this.props.user;
        const list = channelDefsToAdd;

        return (
            <AppPanel  breadcrumbParams={[
                {type: types['organisations'], data: this.props.user.organisation}]
            } title={this.props.intl.formatMessage(messages.title)}>
                    <h1 className="title-underline"><FormattedMessage  defaultMessage="Choose Application to add" id="channel.add.chooseOne"/></h1>

                    <div className="input-group" style={{maxWidth: '200px', marginBottom: '1em'}}>
                        <input className="form-control" name="search" onChange={this.onChange} placeholder={this.props.intl.formatMessage(messages.search)} type="text" />
                        <span className="input-group-addon" id="basic-addon2"><span className="fa fa-search"/></span>
                    </div>

                    <GridList
                        edges={list}
                        getUrl={this.getUrl}
                        iconProperty="icon"
                        metadata={types['channelDefs']}
                        pageInfo={channelDefsToAdd.pageInfo}
                        relay={this.props.relay}
                        tagsProperty="state"
                        titleProperty="name"
                        urlMapping={urlMapping}
                    />
            </AppPanel>
        );
    }
}


export default Relay.createContainer(wrapNotFound(injectIntl(ChannelAdd), (props) => {
    return props.user.organisation;
}), {
    initialVariables: {
        organisationId: '',
        first: defaultPageSize,
        after: null,
        searchName: '',
    },
    prepareVariables (variables) {
        processPagingParams(variables);

		if (!variables.organisationId) {
            variables.organisationId = getLastOrganisationId();
        }

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    realId,
                },
                channelDefsToAdd(first: $first, after: $after, nameLike: $searchName) {
                    edges {
                        node {
                            id,
                            name,
                            icon
                        }
                    },
                    pageInfo {
                        hasNextPage,
                        hasPreviousPage,
                        startCursor,
                        endCursor
                    }

                }
            }
        `,
    },
});
